import { AxiosError } from 'axios';
import { KeyedMutator } from 'swr/dist';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Beneficiary, BeneficiaryList } from '../../domain/Beneficiary/entities';

export enum BeneficiariesActionEnum {
  edit = 'EDIT',
  delete = 'DELETE',
  create = 'CREATE',
}

export type BeneficiariesState = {
  action: Nullable<BeneficiariesActionEnum>;
  beneficiaries: Nullable<Beneficiary[]>;
  totalBeneficiaries: number;
  selectedBeneficiary: Nullable<Beneficiary & { timestamp: string }>;
  beneficiaryToDelete: Nullable<Beneficiary & { timestamp: string }>;
  filters: BeneficiariesListFiltersType;
  onBeneficiaryAction: (selectedBeneficiary: Beneficiary, action: BeneficiariesActionEnum) => void;
  onDeleteBeneficiary: () => void;
  onResetSelectedBeneficiary: () => void;
  onBeneficiariesListFiltersChange: (newFilters: BeneficiariesListFiltersType) => void;
  loadingState: {
    isLoadingBeneficiaries: boolean;
    isLoadingDeleteBeneficiary: boolean;
  };
  errorState: {
    beneficiariesDataError?: AxiosError<
      APIGatewayResponse<unknown>,
      { code: string; type: string; param: string; message: string }
    >;
    deleteBeneficiaryError?: AxiosError<
      APIGatewayResponse<unknown>,
      { code: string; type: string; param: string; message: string }
    >;
  };
  deleteBeneficiaryData: any;
  beneficiariesRefetch: KeyedMutator<BeneficiaryList> | undefined;
};

export enum BeneficiariesContextActionTypes {
  GetBeneficiaries = '@@Account/GET_BENEFICIARIES',
  SetSelectedBeneficiary = '@@Account/SET_SELECTED_BENEFICIARY',
  DeleteBeneficiary = '@@Account/DELETE_BENEFICIARY',
  ResetSelectedBeneficiary = '@@Account/RESET_SELECTED_BENEFICIARY',
  SetBeneficiariesListFilters = '@@Account/SET_BENEFICIARIES_LIST_FILTERS',
}

export type BeneficiariesListFiltersType = {
  page?: number;
  perPage?: number;
};
